(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
document.addEventListener('click', (event) => {
  document.querySelectorAll('.als-collection-filters[open]').forEach((panel) => {
    if (!panel.contains(event.target)) panel.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.als-collection-filters[open]').forEach((panel) => {
    panel.open = false;
    panel.querySelector('summary').focus();
  });
});

  } catch(e) { console.error(e); }
})();
})();
